export default __webpack_public_path__ + "images/KU.92dcb07.png";